import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Text, CircularIcon, Colors } from 'library';
import { client, consoleLogInDev } from 'shared';
import { JobAccessorProps } from '../IndeedModels';
import moment from 'moment';

const ABBREVIATIONS = {
    Sunday: 'Su',
    Monday: 'M',
    Tuesday: 'T',
    Wednesday: 'W',
    Thursday: 'Th',
    Friday: 'F',
    Saturday: 'Sa',
} as any;

const IndeedJobCard = ({ jobAccessor, onLoadFail }: JobAccessorProps) => {
    const [jobData, setJobData] = useState<any | undefined>();

    useEffect(() => {
        if (!!jobAccessor) {
            loadJobData();
        }
    }, [jobAccessor]);

    const loadJobData = async () => {
        client(`api/ongoing/public/jobs/?job_accessor=${jobAccessor}`)
            .then((res2) => {
                setJobData(res2);
            })
            .catch((e) => {
                consoleLogInDev(e);
                onLoadFail();
            });
    };

    const getPay = () => {
        let payString = '';
        if (jobData) {
            if (jobData?.rate_min && jobData?.rate_max) {
                payString = `$${jobData.rate_min} - $${jobData.rate_max}/hr`;
            } else if (jobData?.pay) {
                payString = `$${jobData.pay}`;
                if (!jobData?.pay_is_fixed) {
                    payString += '/hr';
                }
            }
        }
        return payString;
    };

    const getDates = () => {
        let dateString = '';
        if (jobData && jobData?.days_of_week) {
            jobData.days_of_week.map((day: string) => {
                if (dateString.length) {
                    dateString += ', ';
                }
                dateString += ABBREVIATIONS[day];
            });
            if (!jobData.start_date && jobData.start_month) {
                dateString += ` - Starting ${jobData.start_month}`;
            } else if (jobData.start_date && jobData.end_date) {
                try {
                    const toDateFormat = 'MMM D, YYYY';
                    dateString += ` - ${moment(jobData.start_date).format(toDateFormat)} - ${moment(
                        jobData.end_date,
                    ).format(toDateFormat)}`;
                } catch (consoleLogInDev) {}
            }
        } else if (jobData && jobData?.start_date) {
            dateString = moment(jobData.start_date).format('dddd, MMM D, YYYY');
        }

        return dateString;
    };

    const getData = (index: number) => {
        if (!jobData) {
            return null;
        }
        switch (index) {
            case 1:
                return (
                    <Text variant="body1">
                        {jobData?.city}, {jobData?.state}
                    </Text>
                );
            case 2:
                return <Text variant="body1">{getDates()}</Text>;
            default:
                return (
                    <>
                        <Text variant="body1">{getPay()}</Text>
                        <br />
                        <Text variant="body2" color={Colors.mediumRed} bold>
                            (+5% from us)
                        </Text>
                    </>
                );
        }
    };

    const getHeading = () => {
        let heading = '';
        if (jobData) {
            if (!!jobData?.headline) {
                heading = `${jobData.headline} - `;
            }
            if (!!jobData?.family_name) {
                heading += `${jobData.family_name} Family`;
            }
        }
        return heading;
    };

    return (
        <Grid container direction="column" spacing={3}>
            <Grid item container direction="row" spacing={1} alignItems="center">
                <Grid item xs={4}>
                    <CircularIcon icon={<></>} backgroundColor={Colors.lightTurq} />
                </Grid>
                <Grid item xs={8}>
                    <Text variant="h2">{getHeading()}</Text>
                </Grid>
            </Grid>
            {Array(3)
                .fill(0)
                .map((_, i) => {
                    return (
                        <Grid item container direction="row" key={`jobitem${i}`} alignItems="center">
                            <Grid item container xs={2} justify="flex-end">
                                <CircularIcon
                                    icon={<></>}
                                    backgroundColor={Colors.lightTurq}
                                    style={{ height: 30, width: 30, marginRight: 10 }}
                                />
                            </Grid>
                            <Grid item xs={10}>
                                {getData(i)}
                            </Grid>
                        </Grid>
                    );
                })}
            <Grid
                item
                style={{
                    borderColor: Colors.grey,
                    borderStyle: 'solid',
                    borderRadius: 22,
                    borderWidth: 1,
                    margin: 15,
                    padding: 20,
                }}
                xs={11}
            >
                <Text variant="body2" textStyle={{ width: '100%' }}>
                    {jobData?.family_comments}
                </Text>
            </Grid>
        </Grid>
    );
};

export default IndeedJobCard;
